import styles from "./FloatingInput.module.css";
import FieldHint from "./FieldHint";

interface FloatingInputProps {
  name: string;
  label: string;
  type?: "text" | "email" | "tel" | "number";
  value: string;
  onChange: (name: string, value: string) => void;
  error?: string;
  required?: boolean;
  maxLength?: number;
  placeholder?: string;
  isTextarea?: boolean;
  rows?: number;
  /** Aide contextuelle affichée sous le label, au-dessus du champ. */
  hint?: string;
}

export default function FloatingInput({
  name,
  label,
  type = "text",
  value,
  onChange,
  error,
  required,
  maxLength,
  placeholder,
  isTextarea,
  rows = 4,
  hint,
}: FloatingInputProps) {
  const inputClass = `${styles.input} ${error ? styles.hasError : ""} ${
    isTextarea ? styles.textarea : ""
  }`;
  const hintId = hint ? `${name}-hint` : undefined;

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={name}>
        {label}
        {required && " *"}
      </label>
      {hint && <FieldHint id={hintId}>{hint}</FieldHint>}
      {isTextarea ? (
        <textarea
          id={name}
          name={name}
          className={inputClass}
          value={value}
          onChange={(e) => onChange(name, e.target.value)}
          maxLength={maxLength}
          rows={rows}
          placeholder={placeholder}
          aria-describedby={hintId}
        />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          className={inputClass}
          value={value}
          onChange={(e) => onChange(name, e.target.value)}
          maxLength={maxLength}
          placeholder={placeholder}
          aria-describedby={hintId}
        />
      )}
      {error && <span className={styles.errorLabel}>{error}</span>}
    </div>
  );
}
